import { createContext, useCallback, useContext, useState } from 'react'

import { useNavbarStorage } from '@/app/panel/_hooks/use-navbar-storage'

type Expanded = boolean

type ContextNavbarState = {
  expanded: Expanded
  setExpanded: React.Dispatch<Expanded>
}

type ContextNavbarProps = {
  children: React.ReactNode
  initialValue?: Expanded
}

const NavbarContext = createContext<ContextNavbarState | null>(null)

const NavbarContextProvider = ({
  children,
  initialValue,
}: ContextNavbarProps) => {
  const [expanded, setExpandedState] = useState(initialValue ?? true)
  const { setExpandedStorage } = useNavbarStorage()

  const setExpanded = useCallback(
    (newValue: Expanded) => {
      setExpandedStorage(newValue)

      setExpandedState(newValue)
    },
    [setExpandedStorage],
  )

  return (
    <NavbarContext.Provider value={{ expanded, setExpanded }}>
      {children}
    </NavbarContext.Provider>
  )
}

const useNavbarContext = () => {
  const context = useContext(NavbarContext)

  if (!context) {
    throw new Error(
      'useNavbarContext can only be used inside NavbarContextProvider',
    )
  }

  return context
}

export { NavbarContextProvider, useNavbarContext }
